var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "131.25 61.25 437.5 437.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350 288.75c62.719 0 113.75-51.031 113.75-113.75s-51.031-113.75-113.75-113.75-113.75 51.031-113.75 113.75 51.031 113.75 113.75 113.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.53 303.62c-3.1484-1.9414-7.1836-1.6875-10.09 0.64844-29.906 24.191-66.023 36.984-104.44 36.984s-74.523-12.793-104.43-36.984c-2.8789-2.3359-6.9297-2.5977-10.09-0.64844-65.266 40.188-104.23 109.86-104.23 186.38 0 4.8398 3.9219 8.75 8.75 8.75h420c4.8398 0 8.75-3.9102 8.75-8.75 0-76.52-38.965-146.2-104.22-186.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon-account.d1198eb6d1fd3921ad1f29761d940a32.svg";
export { ForwardRef as ReactComponent };